var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-5 max-w-5xl mx-auto" },
    [
      _c("div", { staticClass: "flex flex-col" }, [
        _c(
          "div",
          {
            staticClass:
              "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          },
          [
            _vm.jobs.docs && _vm.jobs.docs.length > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                  },
                  [
                    _c("table", { staticClass: "min-w-full" }, [
                      _vm._m(0),
                      _c(
                        "tbody",
                        { staticClass: "bg-white" },
                        _vm._l(_vm.jobs.docs, function(job) {
                          return _c(
                            "tr",
                            {
                              key: job.id,
                              staticClass:
                                "grid grid-cols-2 grid-flow-row md:table-row"
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(job.order.orderNumber) + " "
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(job.order.customer.firstName) +
                                      " " +
                                      _vm._s(job.order.customer.lastName) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          job.order.createdDate
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                },
                                [
                                  job.scheduledTime
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateFilter")(
                                                job.scheduledTime
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
                                },
                                [
                                  job.order.isReviewRequestSent
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                                        },
                                        [_vm._v(" Review request sent ")]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                                        },
                                        [_vm._v(" Review request not sent ")]
                                      )
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "px-1 md:px-3 py-2 md:py-4 border-b border-gray-200 text-xs leading-5 font-medium text-gray-900 whitespace-pre-wrap"
                                },
                                [
                                  job.scheduledTime != null
                                    ? _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.sendNow(job)
                                            }
                                          }
                                        },
                                        [_vm._v(" Send Now ")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("Pagination", {
                      attrs: { page: _vm.jobs },
                      on: { pageChanged: _vm.loadPage }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isLoading && _vm.jobs.docs && _vm.jobs.docs.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                  },
                  [
                    _vm._v(
                      " You don't have any message logs right now. We will be listing them here as soon as we sent a message. "
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ]),
      _c("Notification", {
        attrs: { text: _vm.notificationText, show: _vm.showNotification }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "hidden md:table-row" }, [
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Order Id ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Customer name ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Order created at ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Message Scheduled at ")]
        ),
        _c(
          "th",
          {
            staticClass:
              "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v(" Message Status ")]
        ),
        _c("th", {
          staticClass:
            "px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }